import React from 'react';

import { useToggle } from 'react-use';
import AddRoundedIcon from '@mui/icons-material/AddRounded';
import RemoveRoundedIcon from '@mui/icons-material/RemoveRounded';

import classes from './CollapsibleInfoBox.module.scss';
import { InfoBox, InfoBoxProps } from '../InfoBox/InfoBox';

type CollapsableInfoBoxProps = Omit<InfoBoxProps, 'hideConfig'> & {
  defaultOpen?: boolean;
};

const CollapsableInfoBox = ({ defaultOpen, ...props }: CollapsableInfoBoxProps) => {
  const [isOpen, toggleOpen] = useToggle(!!defaultOpen);

  const Icon = isOpen ? RemoveRoundedIcon : AddRoundedIcon;

  return (
    <InfoBox
      {...props}
      hideConfig={{ show: isOpen }}
      icon={
        <>
          <Icon />
          <button className={classes.button} type="button" onClick={toggleOpen}></button>
        </>
      }
    />
  );
};

export { CollapsableInfoBox };
